
// vue
import { defineComponent, onBeforeMount, ref, watch } from 'vue';

// services
import { useEnvironmentService } from '@/api/service/environment.service';
import { useEventLogService } from '@/api/service/event-log-service';

// hooks
// import { useToast } from 'vue-toastification';

// configs
import { errorLogConfig } from '@/config/event-log-config';

export default defineComponent({
    components: {},
    setup() {
        // services
        const { getErrorLog } = useEventLogService();
        const { environments, getEnvironmentAll } = useEnvironmentService();

        // hooks

        const errorLogs = ref<any>([])

        const isLoading = ref(true);
        const isEditing = ref(false);
        const isLoadingEditor = ref(false);
        const isEnvSelected = ref(false);

        const selectedEnvironmentId = ref(0);

        const currentPage = ref<number>(1);
        const isResetPage = ref(false)

        const filterData = ref<any>({
            accountId: 0,
            startDate: undefined,
            endDate: undefined
        })

        const populateTableData = async (): Promise<void> => {
            if (selectedEnvironmentId.value === 0) return;

            if(isResetPage.value){
                currentPage.value = 1;
            }

            try{
                isLoading.value = true;
                const res = await getErrorLog(
                                                        selectedEnvironmentId.value, 
                                                        currentPage.value, 
                                                        filterData.value.accountId, 
                                                        filterData.value.startDate, 
                                                        filterData.value.endDate
                                                    ); 
                errorLogs.value = [...(res||[])]
                isResetPage.value = false;
                isLoading.value = false;
            }
            catch(e){
                //@ts-ignore
                console.log("Error:", e)
            }
            finally{
                isLoading.value = false;
            }
        };

        const getNextPage = async () => {
            currentPage.value = currentPage.value + 1
            await populateTableData()
        }

        const getPrevPage = async () => {
            if(currentPage.value > 1){
                currentPage.value = currentPage.value - 1
                await populateTableData()
            }
        }

        const resetFilters = () => {
            filterData.value = {
                accountId: 0,
                startDate: undefined,
                endDate: undefined
            }
            currentPage.value = 1;
        }

        const resetTargetEnv = (): void => {
            resetFilters()
            selectedEnvironmentId.value = 0;
        };

        const applyFilters = async () => {
            await populateTableData()
        }

        // watch
        watch(
            selectedEnvironmentId,
            async (): Promise<void> => {
                isEnvSelected.value = !isEnvSelected.value;
                resetFilters();
                await populateTableData();
            },
        );

        watch(
            filterData,
            ()  => {
                isResetPage.value = true
            },
            { deep: true}
        );


        // lifecycle
        onBeforeMount(async () => {
            isLoading.value = true;

            await getEnvironmentAll();

            isLoading.value = false;
        });

        // configs
        const gridConfig = [
            ...errorLogConfig,
        ];

        return {
            isEditing,
            isLoading,
            gridConfig,
            errorLogs,
            environments,
            isEnvSelected,
            resetTargetEnv,
            isLoadingEditor,
            errorLogConfig,
            selectedEnvironmentId,
            getNextPage,
            getPrevPage,
            currentPage,
            filterData,
            applyFilters
        };
    },
});
